import { VFC, useMemo } from 'react';
import { GasMeasurementCategory } from '@enmon/commons';
import { FormattedMessage, useIntl } from 'react-intl';
import { Select } from '../../Select';
import { SelectMessages as messages } from '../../messages';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface GasMeasurementCategorySelectProps {
  value?: GasMeasurementCategory;
  onChange?: (value: GasMeasurementCategory) => void;
}

export const GasMeasurementCategorySelect: VFC<GasMeasurementCategorySelectProps> = ({
  ...restProps
}: GasMeasurementCategorySelectProps) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const gasMeasurementCategoryOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(GasMeasurementCategory),
        suggestedValue: meterModelSuggestions?.measurementCategory?.value,
        suggestedSelection: meterModelSuggestions?.measurementCategory?.selection,
      }),
    [intl, meterModelSuggestions],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={gasMeasurementCategoryOptions}
      placeholder={<FormattedMessage {...messages.measurementCategoryPlaceholder} />}
      {...restProps}
    />
  );
};
